module.exports = __webpack_public_path__ + "static/media/ppt.68dc6189.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/ppt.svg
// module id = 1687
// module chunks = 17